import { DISTRIBUTION_REDUCER_NAMESPACE } from "../reducers/distribution";

export const DistributionActions = {
    SET_FILTERS_OPTIONS_MAP: `${DISTRIBUTION_REDUCER_NAMESPACE}/SET_FILTERS_OPTIONS_MAP`,
}

export const setFiltersOptionsMap = (filtersOptionsMap: Record<string, any[]>) => {
    return { type: DistributionActions.SET_FILTERS_OPTIONS_MAP, filtersOptionsMap }
}